var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 0.357879V12.8229L1.68002 15.8609C1.57496 15.9347 1.45269 15.9804 1.32493 15.9934C1.19716 16.0065 1.06819 15.9865 0.950361 15.9354C0.832532 15.8843 0.729795 15.8039 0.651992 15.7017C0.57419 15.5995 0.523928 15.4791 0.506023 15.3519L0.499023 15.2479V4.61488C0.49903 4.5121 0.52016 4.41043 0.561101 4.31616C0.602043 4.22189 0.661922 4.13704 0.737023 4.06688L0.817023 4.00188L6.00002 0.357879ZM18.494 0.647879L18.501 0.751879V11.3849C18.501 11.4877 18.4799 11.5893 18.4389 11.6836C18.398 11.7779 18.3381 11.8627 18.263 11.9329L18.183 11.9979L13 15.6399V3.17388L17.32 0.138879C17.4251 0.0650206 17.5474 0.0193785 17.6751 0.00632549C17.8029 -0.00672754 17.9319 0.0132461 18.0497 0.0643323C18.1675 0.115418 18.2703 0.195906 18.3481 0.298084C18.4259 0.400261 18.4761 0.520706 18.494 0.647879ZM7.50002 0.358879L11.5 3.17088V15.6379L7.50002 12.8239V0.358879Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.90b1be2b83e39dddfd4ed6312297d026.svg";
export { ForwardRef as ReactComponent };